module.exports = __webpack_public_path__ + "static/boxes-ef0436aa53c87799e6bd0de9998f6e1e.jpg";